import styles from './PhotoItem.module.css'
import DialogCamShot from "../DialogCamShot/DialogCamShot";
import BioImageItem from "../BioImageItem/BioImageItem";
import ButtonContainer from "../../../../FormTemplate/ButtonContainer/ButtonContainer";
import React, {useEffect, useState} from "react";
import DialogFullView from "../DialogFullView/DialogFullView";
import noImage from '../../../../Img/Biometric/shot.svg'

interface IPhotoItemProps
{
    img?:string
    title?:string
    needUpdate?:boolean
    frameType?:number
    canPhoto?:boolean
    onPhoto: (data:string)=>void
    onUpdate?: ()=>void
    load:boolean
    imgHeight?:number

}

export default function PhotoItem({load,onPhoto,onUpdate,canPhoto,frameType,needUpdate,img,imgHeight,title}:IPhotoItemProps){
    const [dgShot, setDgShot] = useState(false)
    const [dgFullView, setDgFullView] = useState(false)

    const [image, setImage] = useState(img ? img : noImage)
    const [noImageFlag, setNoImageFlag] = useState(true)

    const _canPhoto = canPhoto !== undefined ? canPhoto : true
    //console.log("insert",img)

    useEffect(()=>{
        if(! img || img === noImage){
            setImage(noImage)
            setNoImageFlag(true)
            return
        }
        setImage(img)
        setNoImageFlag(false)
    },[img])

    const handleFullImage = (image: any) =>{
        if(!image || noImageFlag ) return
        setDgFullView(true)
    }

    const handleShot=(data: string)=>{


        if(onPhoto) onPhoto(data)
        setDgShot(false)
        //setImage(data)

    }


    async function handleClear  (){
        console.log("clear", onPhoto)
        setImage(noImage)
        if(onPhoto) onPhoto((noImage))

    }


    const maxHeight = imgHeight ? `${imgHeight}px`: "300px"

    const buildBlurCont = (vl:boolean)=>{
        if(!vl) return null
        return (
            <div className={styles.blurCont}>
                <div className={styles.blurData}>Обновите</div>
            </div>
        )
    }

    return(
        <div className={styles.mainCont}>
            <div className={styles.crShot}
                onClick={()=>handleClear()}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"><path d="m17.06 16 7.97 7.97-1.06 1.06L16 17.06l-7.97 7.97-1.06-1.06L14.94 16 6.97 8.03l1.06-1.06L16 14.94l7.97-7.97 1.06 1.06L17.06 16Z" fill="currentColor"></path></svg>
            </div>

            {dgShot && <DialogCamShot onShot={(e)=>handleShot(e)} frameId={frameType} maxWidth={500} onClose={()=>setDgShot(false)}/>}
            {dgFullView && img && <DialogFullView onClose={()=>setDgFullView(false)} img={image}/>}
            <div className={styles.title}>
                {title ? title : ""}
            </div>
            <div className={styles.imgCont} style={{height: maxHeight }}>
                {needUpdate && !load && buildBlurCont(needUpdate)}
                <BioImageItem onClick={()=>handleFullImage((img))} img={image} loading={load} imgCss={styles.imgItem}/>
            </div>


            <ButtonContainer resize={true} clsCont={styles.fcBut}>
                <button type="button" className="btn btn-secondary "
                        onClick={()=>setDgShot(true)}
                        disabled={!_canPhoto}
                >Снять</button>
                {onUpdate &&
                    <button type="button" className="btn btn-secondary "
                            onClick={()=>{
                                if(onUpdate)onUpdate()
                            }}
                            disabled={!_canPhoto}
                    >Обновить</button>

                }

            </ButtonContainer>

        </div>
    )
}